module.exports = __webpack_public_path__ + "img/objetos-14.d5c492ff.png";